// 홈 화면 문구(운영자 편집) — FR-LAND.
// 엣지가 없거나 미게시면 코드의 기본값(shared DEFAULT_SITE_TEXT)을 그대로 쓴다 —
// 홈은 서버 없이도 항상 떠야 한다(불변식 3).
import { sanitizeSiteText, DEFAULT_SITE_TEXT, type SiteText } from "@greg-chick/shared";
import { EDGE_BASE } from "./apiBase";
import { fetchEarlyOr } from "./earlyFetch";

/**
 * 문구를 쓰는 화면이 여럿이다(첫 화면·안내·체험공간 셸). 캐시가 없으면 **각자 받아 온다** —
 * 실측(2026-08-22) 첫 화면에서만 두 번이었다. 매니페스트와 같은 방식으로 합친다.
 *
 * 🔴 운영자가 문구를 고치면 **바로 반영돼야 한다.** 그래서 실시간 게시(`sitetext`)를 받는
 * 화면들이 `resetSiteText()` 를 부른 뒤 다시 읽는다 — 캐시를 넣으면서 그 길을 같이 낸다.
 * 안 그러면 「관리자에서 고쳤는데 화면이 그대로」가 된다.
 */
let cache: SiteText | null = null;
let inflight: Promise<SiteText> | null = null;

export function resetSiteText(): void {
  cache = null;
}

export async function loadSiteText(): Promise<SiteText> {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      // 책 화면에서는 index.html 이 먼저 띄워 둔 것을 받아 쓴다(없으면 직접 · lib/earlyFetch)
      const res = await fetchEarlyOr(`${EDGE_BASE}/api/site-text`, { cache: "no-store" });
      if (!res.ok) return DEFAULT_SITE_TEXT; // 미게시 — 기본값(캐시하지 않는다)
      const body = (await res.json()) as { text?: unknown };
      cache = sanitizeSiteText(body.text); // 응답도 외부 입력이다(불변식 7)
      return cache;
    } catch {
      return DEFAULT_SITE_TEXT; // 오프라인 — 기본값(캐시하지 않는다: 붙으면 다시 시도)
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}
